import React from 'react'

import CONST from '../../constants'

import Extra from '../layout/extra'
import Main from '../layout/main'

import styles from './detail-page-container.module.css'

const DetailPageContainer = ({ children }) => {
  return (
    <div className={styles.container}>
      <Main border={false}>{children}</Main>
      <Extra />
    </div>
  )
}

export default DetailPageContainer
